import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=04997840&scoped=true&"
import script from "./addCategory.vue?vue&type=script&lang=js&"
export * from "./addCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04997840",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04997840')) {
      api.createRecord('04997840', component.options)
    } else {
      api.reload('04997840', component.options)
    }
    module.hot.accept("./addCategory.vue?vue&type=template&id=04997840&scoped=true&", function () {
      api.rerender('04997840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/addCategory.vue"
export default component.exports